import React, { useEffect, createElement } from 'react';
import { AlertBanner } from './components/AlertBanner';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { AvatarSection } from './components/AvatarSection';
import { IncludedSection } from './components/IncludedSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    const initPixel = () => {
      const f = window as any;
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      f.fbq('init', '27856287660637797');
      f.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-bg text-brand-text overflow-x-hidden" data-id="element-0">
      <AlertBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AvatarSection data-id="element-4" />
      <IncludedSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <PricingCard data-id="element-7" />
      <Guarantee data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
      <SocialProofPopup data-id="element-13" />

      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-14">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=27856287660637797&ev=PageView&noscript=1" alt="" data-id="element-15" />
      </noscript>
    </div>;
}